const React = require("react");
const {object, string} = require("yup");
const trim = require("mn-utils/trim");
const toLower = require("mn-utils/toLower");

const {replaceLocation, Link} = require("../../../router");
const {LINK_PASSWORD_RESET, LINK_SIGN_IN} = require("../../../constants/links");
const {FormWrapper, FormSubmitBtn} = require("../../dumb/FormHandlers");
const Base = require("../../smart/Page/AuthLayout");
const {AuthInput, AuthInputPassword} = require("../../dumb/FormInputs");
const {decorateReconnect, apiAuthPasswordRecovery} = require("../../../api/_auth");

const sendRecoveryToken = decorateReconnect(apiAuthPasswordRecovery);

module.exports = (props) => {
  const trimHandler = [trim];

  const schema = object({
    token: string().uuid('Please enter the token that was sent to your email.').required(),
    password: string()
        .isValidNewPwd()
        .isValidPwdLength()
        .withoutCyrillicSymbols()
        .required()
  });

  const onSubmit = (data) => (
    sendRecoveryToken(data)
  );

  const onResult = () => {
    replaceLocation({
      path: LINK_SIGN_IN,
    })
  };

  const resultModalData = ['Your password has been changed!', 'Please try to login again.'];

  return (
    <FormWrapper
      data={{token: (props.params || {}).token}}
      schema={{default: schema}}
      onSubmit={onSubmit}
      onResult={onResult}
      resultModalData={resultModalData}
    >
      {(formCtx) => (
        <Base
          title="Reset password"
          description="Set a new password"
          content={(
            <>
              <div className="mb30">
                <AuthInput
                  label="Reset Token"
                  name="token"
                  formCtx={formCtx}
                  onChangeHandlers={trimHandler}
                />
              </div>
              <div>
                <AuthInputPassword
                  label="New Password"
                  name="password"
                  formCtx={formCtx}
                  onChangeHandlers={trimHandler}
                />
              </div>
            </>
          )}
          beforeFooter={(
            <div className="ph25 pt15 pb35 lh18 lts0em">
              <Link
                href={LINK_SIGN_IN}
                className="c5B47FF olN tdU dn f12 fw3 o70:h"
              >I have a password</Link>
            </div>
          )}
          control={(
            <FormSubmitBtn formCtx={formCtx}>
              Reset password
            </FormSubmitBtn>
          )}
        />
      )}
    </FormWrapper>
  )
}
